import { createAsyncThunk } from '@reduxjs/toolkit';
import { errorGlobal, successGlobal } from '../reducers/notifications';
import { getAuthHeader } from '../../utils/tools';
import axios from 'axios';

axios.defaults.headers.post['Content-Type'] = 'application/json';

// Create Client
export const addClient = createAsyncThunk(
    'client/addClient',
    async(client, { dispatch }) => {
        try{
            const request = await axios.post(`/api/client/create`, client ,getAuthHeader());
            dispatch(successGlobal('Dodávateľ/odberateľ bol úspešne vytvorený.'));
            return request.data;
        } catch(error) {
            dispatch(errorGlobal('Dodávateľa/odberateľa sa nepodarilo pridať.'));
            throw error;
        }
    }
);

// Fetch clients
export const fetchClients = createAsyncThunk(
    'client/fetchClients',
    async(category, {dispatch}) => {
        try {
            const query = category ? `?category=${encodeURIComponent(category)}` : '';
            const request = await axios.get(`/api/client/fetch${query}`, getAuthHeader());
            return request.data;
        } catch(error) {
            dispatch(errorGlobal('Dodávateľov/odberateľov sa nepodarilo načítať.'));
            throw error;
        }
    }
);

// Detail client
export const detailClient = createAsyncThunk(
    'client/detailClient',
    async(id, {dispatch}) => {
        try {
            const request = await axios.get(`/api/client/detail/${id}`, getAuthHeader());
            return request.data;
        } catch(error) {
            dispatch(errorGlobal('Dodávateľa/odberateľa sa nepodarilo načítať.'));
            throw error;
        }
    }
);

// Edit client
export const editClient = createAsyncThunk(
    'client/editClient',
    async(client, {dispatch}) => {
        try {
            const request = await axios.patch(`/api/client/update/${client.id}`, client, getAuthHeader());
            dispatch(successGlobal('Dodávateľ/odberateľ bol úspešne upravený.'));
            return request.data;
        } catch(error) {
            dispatch(errorGlobal('Dodávateľa/odberateľa sa nepodarilo upraviť.'));
            throw error;
        }
    }
);

// Can delete client
export const canDeleteClient = createAsyncThunk(
    'client/canDeleteClient',
    async(id, {dispatch}) => {
        try {
            const request = await axios.get(`/api/client/can-delete/${id}`, getAuthHeader());
            return request.data;
        } catch(error) {
            throw error;
        }
    }
);

// Delete client
export const deleteClient = createAsyncThunk(
    'client/deleteClient',
    async(clientId, {dispatch}) => {
        try {
            const request = await axios.delete(`/api/client/delete/${clientId}`, getAuthHeader());
            dispatch(successGlobal('Dodávateľ/odberateľ bol úspešne vymazaný.'));
            return request.data;
        } catch(error) {
            dispatch(errorGlobal('Dodávateľa/odberateľa sa nepodarilo vymazať.'));
            throw error;
        }
    }
);

// Add branch to client
export const addBranch = createAsyncThunk(
    'client/addBranch',
    async({ clientId, name, address }, { dispatch }) => {
        try {
            const request = await axios.post(`/api/client/${clientId}/branch`, { name, address }, getAuthHeader());
            dispatch(successGlobal('Prevádzkareň bola úspešne pridaná.'));
            return request.data;
        } catch(error) {
            dispatch(errorGlobal('Prevádzkareň sa nepodarilo pridať.'));
            throw error;
        }
    }
);

// Update branch
export const updateBranch = createAsyncThunk(
    'client/updateBranch',
    async({ clientId, branchId, name, address }, { dispatch }) => {
        try {
            const request = await axios.patch(`/api/client/${clientId}/branch/${branchId}`, { name, address }, getAuthHeader());
            dispatch(successGlobal('Prevádzkareň bola úspešne upravená.'));
            return request.data;
        } catch(error) {
            dispatch(errorGlobal('Prevádzkareň sa nepodarilo upraviť.'));
            throw error;
        }
    }
);

// Can delete branch
export const canDeleteBranch = createAsyncThunk(
    'client/canDeleteBranch',
    async({ clientId, branchId }, { dispatch }) => {
        try {
            const request = await axios.get(`/api/client/${clientId}/branch/${branchId}/can-delete`, getAuthHeader());
            return request.data;
        } catch(error) {
            throw error;
        }
    }
);

// Delete branch
export const deleteBranch = createAsyncThunk(
    'client/deleteBranch',
    async({ clientId, branchId }, { dispatch }) => {
        try {
            const request = await axios.delete(`/api/client/${clientId}/branch/${branchId}`, getAuthHeader());
            if (request.data === true) {
                dispatch(successGlobal('Prevádzkareň bola úspešne vymazaná.'));
            } else {
                dispatch(errorGlobal('Prevádzkareň sa nedá vymazať, pretože je priradená k záznamu o odpade.'));
            }
            return request.data;
        } catch(error) {
            dispatch(errorGlobal('Prevádzkareň sa nepodarilo vymazať.'));
            throw error;
        }
    }
);